import type { InsuranceOfferWithSelectedState } from '@backmarket/http-api'

import { isDefaultOfferSelected } from './isDefaultOfferSelected'

export function hasInsuranceSelected(
  insuranceOffers: InsuranceOfferWithSelectedState[],
) {
  return !insuranceOffers.some(isDefaultOfferSelected)
}
